import PoweredByHooplaColorIcon from '../components/PoweredByHooplaColorIcon'
import PoweredByHooplaWhiteIcon from '../components/PoweredByHooplaWhiteIcon'
import type { FC } from 'react'
import type { PoweredByHooplaIconProps } from '../PoweredByHooplaIcon'

type PoweredByHooplaIconUIProps = PoweredByHooplaIconProps & {
  /** The label for the icon (so assistive tech can read it) */
  label: string
}

/**
 * Presenter component in container/presenter pattern - this should only handle
 * how the component looks. All logic should be in `PoweredByHooplaIcon`.
 * */
const PoweredByHooplaIconUI: FC<PoweredByHooplaIconUIProps> = ({
  isDarkMode,
  label,
}: PoweredByHooplaIconUIProps) => {
  return (
    <div>
      <span className="sr-only">{label}</span>
      {isDarkMode ? <PoweredByHooplaWhiteIcon /> : <PoweredByHooplaColorIcon />}
    </div>
  )
}

export default PoweredByHooplaIconUI
